import { Box } from '@mui/material';
import type { ReactElement } from 'react';

export const WEB_BUILDER_ACCESS_TOOLTIP =
  'Controls whether this organisation can access the website builder. Turn on to let them create and manage their pharmacy website. Turn off to show them the on-boarding journey.';

export const BESPOKE_TOOLTIP =
  'Marks this organisation as having a bespoke (custom-built) website rather than a standard template site. Turning this on will prevent the customer from modifying the standard template homepage.';

export const WEBSITE_STATUS_TOOLTIP =
  'Controls whether the pharmacy website is published on the intended domain. Switching off takes down the website and affects linking to their website in our system (email links for example).';

export const DOMAIN_URL_TOOLTIP = 'The web address the pharmacy website is served on.';

export const EXTERNAL_HOMEPAGE_URL_TOOLTIP =
  "Point the website's home page at an external URL instead of the built-in homepage. Leave empty to remove it and use the built-in homepage.";

export const GOOGLE_TAG_MANAGER_ID_TOOLTIP =
  'The Google Tag Manager container ID (starts with GTM-) that loads on the pharmacy website, letting the customer manage their own tracking tags. Leave empty to disable Tag Manager.';

export const GOOGLE_MEASUREMENT_ID_TOOLTIP =
  'The Google Analytics 4 measurement ID (starts with G-) used to send website traffic data to the customer\u2019s GA4 property. Leave empty to disable Google Analytics.';

export function OnboardingJourneyTooltip(): ReactElement {
  return (
    <Box className="vtwo:flex vtwo:flex-col vtwo:gap-2">
      <span>
        <strong>Just Select Pharmacy:</strong> Patient is tied to one pharmacy with no
        delivery/collection choice; on single-pharmacy sites it&apos;s auto-assigned.
      </span>
      <span>
        <strong>Delivery (commissionable) / Collection:</strong> Adds a &ldquo;how do you want your
        medicines?&rdquo; step: get them delivered by a postal partner, or collect from a nearby
        pharmacy.
      </span>
      <span>
        <strong>Marketplace Delivery Options:</strong> No pharmacy fixed up front; patient sees
        delivery options across pharmacies and isn&apos;t forced to nominate one before ordering.
      </span>
    </Box>
  );
}
